export const GET_HARDWARE_FORM_DATA_REQUEST = 'GET_HARDWARE_FORM_DATA_REQUEST';
export const GET_HARDWARE_FORM_DATA_SUCCESS = 'GET_HARDWARE_FORM_DATA_SUCCESS';
export const GET_HARDWARE_FORM_DATA_FAILURE = 'GET_HARDWARE_FORM_DATA_FAILURE';

export const GET_HARDWARE_DASHBOARD_REQUEST = 'GET_HARDWARE_DASHBOARD_REQUEST';
export const GET_HARDWARE_DASHBOARD_SUCCESS = 'GET_HARDWARE_DASHBOARD_SUCCESS';
export const GET_HARDWARE_DASHBOARD_FAILURE = 'GET_HARDWARE_DASHBOARD_FAILURE';

export const CREATE_PSP_PAYMENT_REQUEST = 'CREATE_PSP_PAYMENT_REQUEST';
export const CREATE_PSP_PAYMENT_SUCCESS = 'CREATE_PSP_PAYMENT_SUCCESS';
export const CREATE_PSP_PAYMENT_FAILURE = 'CREATE_PSP_PAYMENT_FAILURE';

export const CREATE_DIRECT_PAYMENT_REQUEST = 'CREATE_DIRECT_PAYMENT_REQUEST';
export const CREATE_DIRECT_PAYMENT_SUCCESS = 'CREATE_DIRECT_PAYMENT_SUCCESS';
export const CREATE_DIRECT_PAYMENT_FAILURE = 'CREATE_DIRECT_PAYMENT_FAILURE';

export const UPDATE_DIRECT_PAYMENT_REQUEST = 'UPDATE_DIRECT_PAYMENT_REQUEST';
export const UPDATE_DIRECT_PAYMENT_SUCCESS = 'UPDATE_DIRECT_PAYMENT_SUCCESS';
export const UPDATE_DIRECT_PAYMENT_FAILURE = 'UPDATE_DIRECT_PAYMENT_FAILURE';

export const CLEAR_PAYMENT_ID = 'CLEAR_PAYMENT_ID';


export const GET_PROMO_CODE_INFO_REQUEST = 'GET_PROMO_CODE_INFO_REQUEST';
export const GET_PROMO_CODE_INFO_SUCCESS = 'GET_PROMO_CODE_INFO_SUCCESS';
export const GET_PROMO_CODE_INFO_FAILURE = 'GET_PROMO_CODE_INFO_FAILURE';

export const GET_HARDWARE_TRANSACTIONS_REQUEST = "GET_HARDWARE_TRANSACTIONS_REQUEST"
export const GET_HARDWARE_TRANSACTIONS_SUCCESS = "GET_HARDWARE_TRANSACTIONS_SUCCESS"
export const GET_HARDWARE_TRANSACTIONS_FAILURE = "GET_HARDWARE_TRANSACTIONS_FAILURE"